import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { QRCodeComponent } from 'angularx-qrcode';
import { Auth } from '@angular/fire/auth';
import { collection, collectionData, Firestore, getDocs, limit, orderBy, query, where } from '@angular/fire/firestore';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { SopoDialogRef } from 'src/app/sopo-popup/interfaces/dialog';
import { IAccessLogs } from '@soposopo/sopo-models';

interface IAccessLogWithDocId extends IAccessLogs {
    _docId: string;
}

@Component({
    selector: 'app-desktop-location-qr',
    standalone: true,
    imports: [CommonModule, IonicModule, QRCodeComponent],
    templateUrl: './desktop-location-qr.component.html',
    styleUrls: ['./desktop-location-qr.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DesktopLocationQrComponent implements OnInit, OnDestroy {
    qrData: string;
    status: 'waiting' | 'approved' = 'waiting';

    private destroy$ = new Subject<void>();

    constructor(
        private auth: Auth,
        private firestore: Firestore,
        private sopoDialogRef: SopoDialogRef,
        private ref: ChangeDetectorRef,
    ) {}

    ngOnInit() {
        const userId = this.auth.currentUser?.uid;
        if (!userId) {
            this.sopoDialogRef.close(false);
            return;
        }

        this.qrData = `https://link.playsopo.com/desktop-location?userId=${userId}`;

        const accessLogsRef = collection(this.firestore, `users/${userId}/accessLogs`);
        const q = query(accessLogsRef, where('approved', 'in', [true, false]), orderBy('accessTime', 'desc'), limit(1));

        // Snapshot the current latest doc ID so we only react to genuinely new entries
        getDocs(q).then(snapshot => {
            const initialDocId = snapshot.empty ? null : snapshot.docs[0].id;

            collectionData(q, { idField: '_docId' }).pipe(
                takeUntil(this.destroy$),
                filter((docs: IAccessLogWithDocId[]) => docs.length > 0),
                filter((docs: IAccessLogWithDocId[]) => docs[0]._docId !== initialDocId),
            ).subscribe((docs: IAccessLogWithDocId[]) => {
                const latest = docs[0];

                if (latest.approved === true) {
                    this.status = 'approved';
                    this.ref.detectChanges();
                    setTimeout(() => this.sopoDialogRef.close(true), 1000);
                } else {
                    this.sopoDialogRef.close(false);
                }
            });
        });
    }

    close() {
        this.sopoDialogRef.close(this.status === 'approved');
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
